import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=00208f2e&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=js&"
export * from "./JobList.vue?vue&type=script&lang=js&"
import style0 from "./JobList.vue?vue&type=style&index=0&id=00208f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00208f2e",
  null
  
)

export default component.exports